import { ColumnInterface } from '@shared/interfaces/column.interface'
import { OptionsBoardColumnsEnum } from '@shared/components/trading/widgets/options-board-widget/core/enums/options-board-columns.enum'

export const OptionsBoardColumnsConstant: ColumnInterface<OptionsBoardColumnsEnum>[] = [
	{
		column: OptionsBoardColumnsEnum.strike,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.bid,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.ask,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.last,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.change,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.breakeven,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.volatility,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.interest,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.delta,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.gamma,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.theta,
		visible: true,
	},
	{
		column: OptionsBoardColumnsEnum.vega,
		visible: true,
	},
]
